var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF5153"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 7L17.8047 18.8477H14.9922L14.5938 7H18.1914ZM14.5 22.5156C14.5 22.0156 14.6719 21.6016 15.0156 21.2734C15.3672 20.9375 15.8281 20.7695 16.3984 20.7695C16.9766 20.7695 17.4375 20.9375 17.7812 21.2734C18.125 21.6016 18.2969 22.0156 18.2969 22.5156C18.2969 23 18.125 23.4102 17.7812 23.7461C17.4375 24.082 16.9766 24.25 16.3984 24.25C15.8281 24.25 15.3672 24.082 15.0156 23.7461C14.6719 23.4102 14.5 23 14.5 22.5156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuError);
export default __webpack_public_path__ + "static/media/xeu-error.e4eb6a777c4d5776735de3dc968b0fdb.svg";
export { ForwardRef as ReactComponent };